import { render, staticRenderFns } from "./detailPdf2.vue?vue&type=template&id=01da6986"
import script from "./detailPdf2.vue?vue&type=script&lang=js"
export * from "./detailPdf2.vue?vue&type=script&lang=js"
import style0 from "./detailPdf2.vue?vue&type=style&index=0&id=01da6986&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports